// Helpers para transformar un cierre contable en el formato que usan las pantallas de liquidaciones

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const mapClosureToLiquidacion = (closure) => {
  if (!closure) return null;

  // Soporta tanto AccountingClosure como Liquidacion agregada
  const isAggregated =
    closure.facturacionTotal != null ||
    closure.numeroTurnos != null ||
    closure.numeroServicios != null;

  const facturacion = isAggregated
    ? toNumber(closure.facturacionTotal)
    : toNumber(closure.endIncome) - toNumber(closure.startIncome);
  const tarjetas = isAggregated ? toNumber(closure.tarjeta) : toNumber(closure.cardIncome);
  const credito = isAggregated ? 0 : toNumber(closure.creditIncome);
  const gasolina = isAggregated ? toNumber(closure.gastoGasolina) : toNumber(closure.gas);
  const efectivo = isAggregated ? toNumber(closure.efectivo) : facturacion - tarjetas - credito;
  const totalEmpresa = isAggregated ? toNumber(closure.totalEmpresa) : tarjetas + credito;
  const kmLiquidacion = isAggregated
    ? toNumber(closure.kmLiquidacion)
    : toNumber(closure.endKm) - toNumber(closure.startKm);

  const licenseNumber =
    typeof closure.license === "object" && closure.license !== null
      ? closure.license.licenseNumber || closure.license.number || closure.license._id || ""
      : closure.license || closure.licencia || "";

  const fechaInicio = closure.fechaPrimerTurno || closure.date;
  const fechaFin = closure.fechaUltimoTurno || closure.date;
  const fecha = fechaInicio ? new Date(fechaInicio) : null;
  const fechaUlt = fechaFin ? new Date(fechaFin) : fecha;
  const fechaIso = fecha ? fecha.toISOString().slice(0, 10) : "-";
  const fechaUltIso = fechaUlt ? fechaUlt.toISOString().slice(0, 10) : fechaIso;
  const numTurnos = isAggregated ? toNumber(closure.numeroTurnos) : 1;
  const numServicios = (() => {
    if (isAggregated) return toNumber(closure.numeroServicios);
    const servicesFromClosure = Array.isArray(closure.services) ? closure.services.length : 0;
    const servicesFromTurnos = Array.isArray(closure.turnos)
      ? closure.turnos.reduce((acc, t) => acc + (Array.isArray(t?.servicios) ? t.servicios.length : 0), 0)
      : 0;
    return servicesFromTurnos || servicesFromClosure;
  })();

  // Turno principal (para la lista derecha). Si no hay turnos cargados, usa el id de liquidación como fallback.
  const firstTurnoId =
    Array.isArray(closure.turnos) && closure.turnos.length
      ? closure.turnos[0]._id || closure.turnos[0]
      : closure._id || "";

  return {
    id: closure._id || "",
    licencia: licenseNumber || "-",
    conductor: closure.conductor || closure.driver?.name || closure.driverName || "Sin conductor",
    "km-liquidacion": kmLiquidacion,
    "facturacion-liquidacion": facturacion,
    "tarjetas-liquidacion": tarjetas,
    "gasolina-liquidacion": gasolina,
    "total-empresa-liquidacion": totalEmpresa,
    "total-conductor-liquidacion": toNumber(closure.totalConductor),
    "efectivo-liquidacion": efectivo,
    "ganancias-conductor": toNumber(closure.gananciaConductorPct) || efectivo * (closure.driverPct ? closure.driverPct / 100 : 1) || efectivo - gasolina,
    "ganancia-empresa": toNumber(closure.gananciaEmpresaPct) || (facturacion * (1 - (closure.driverPct || 40) / 100) - gasolina),
    "num-turnos": numTurnos || 0,
    "num-servicios": numServicios || 0,
    "fecha-primer-turno": fechaIso,
    "fecha-ultimo-turno": fechaUltIso,
    raw: { ...closure, firstTurnoId },
  };
};
